module.exports = __webpack_public_path__ + "img/3-customer-collab.9583d110.png";